import { AnyAction } from "redux";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { IAppState } from "redux/store/Store";
import { ICultureState } from "redux/reducers/cultureReducer";
import React, { useState, useLayoutEffect } from "react";
import { getIdeasRejected } from 'redux/actions/ideas/IdeaAction';
import { IIdeasRejected } from "redux/types/ideas";
import { Box } from "@material-ui/core";
import IdeaList from "containers/IdeaList/IdeaList";
import Resource from "components/Resources/Resource";
import DynamicInfiniteScroll from "views/KeyTasks/DynamicInfiniteScroll";

interface IDispatchProps {
  getIdeasRejected: (options: object) => Promise<IIdeasRejected>
}

interface IStateProps {
  ideasRejected: IIdeasRejected;
  applicationId: string;
  culture: ICultureState;
  challengeId: string;
  q: string;
}

function IdeasRejected(props: IDispatchProps & IStateProps) {
  const {
    getIdeasRejected,
    ideasRejected,
    challengeId,
    q,
  } = props;
  const [pageNumber] = useState(1);
  const [pageSize] = useState(6);

  useLayoutEffect(() => {
    getIdeasRejected({
      challengeId,
      q,
      pageNumber: pageNumber,
      pageSize: pageSize,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function showMore(typeTabs?: string, pageNumber?: number, pageSize?: number, isInfinite?: boolean) {
    if(typeTabs === 'rejected') {
      getIdeasRejected({
        challengeId,
        q,
        pageNumber,
        pageSize,
        isInfinite
      });
    }
  }

  const notProgressedTitle = <Resource tag="PageIdea::Idea_TitleNotProgressed" />

  return (
    <Box mb={7} className="ideas-page-container">
      <div className="ideas" style={{ paddingTop: "10px" }}>
        <>
          <DynamicInfiniteScroll 
            dataList={ideasRejected} 
            getAction={(pageNumber,pageSize) => showMore('rejected', pageNumber, pageSize, true)}
            pageSize={6}
            isAutomatic
          >
            <IdeaList
              type="rejected"
              //getMoreListIdea={showMore}
              ideasRejected={ideasRejected}
              listHeader={notProgressedTitle}
            />
          </DynamicInfiniteScroll>
        </>
      </div>
    </Box>
  );
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>
): IDispatchProps => {
  return {
    getIdeasRejected: (parameters: object) => dispatch(getIdeasRejected(parameters))
  };
};

const mapStateToProps = (store: IAppState, ownProps: any) => {
  return {
    q: ownProps?.location?.state?.q,
    challengeId: ownProps?.location?.state?.challengeId,
    ideasRejected: store.ideasState.ideasRejected,
    culture: store.cultureState,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IdeasRejected);
